import apiClient from './apiClient';

const supportRequestService = {
  getAll: async (params = {}) => {
    // Default: user-scoped endpoint
    const response = await apiClient.get('/support-requests', { params });
    return response.data;
  },

  getAdminAll: async (params = {}) => {
    const response = await apiClient.get('/admin/support-requests', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await apiClient.get(`/admin/support-requests/${id}`);
    return response.data;
  },

  updateStatus: async (id, status, adminResponse = null) => {
    const response = await apiClient.put(`/support-requests/${id}`, {
      status,
      admin_response: adminResponse
    });
    return response.data;
  },

  addReply: async (id, message) => {
    const response = await apiClient.post(`/admin/support-requests/${id}/replies`, {
      message
    });
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/support-requests/${id}`);
    return response.data;
  }
};

export default supportRequestService;